<template>
  <div></div>
</template>

<script>
import { apiService } from '@/utils/api/index';

export default {
  async created() {
    const data = {
      vendor: this.$route.params.vendorId,
    };

    try {
      const res = await apiService.post(
        '/dashboard_msp/public_profiles/',
        data
      );
      if (res.status < 400) {
        this.$router.push({
          path: `/agency/our-public-profiles/${res.data.id}`,
          query: { id: res.data.id, name: this.$route.params.vendorName },
        });
      } else {
        this.$router.push({ path: '/agency/our-public-profiles' });
      }
    } catch (e) {
      this.$router.push({ path: '/agency/our-public-profiles' });
    }
  },
};
</script>
